import {
  AppBar,
  ListSubheader,
  useMediaQuery,
  useTheme,
  Drawer,
  IconButton,
  MenuList,
  MenuItem,
  Box,
} from '@mui/material'
import { Container, Stack } from '@mui/system'
import MenuIcon from '@mui/icons-material/Menu'
import React, { useState } from 'react'
import { useLocation } from 'react-router-dom'
import AppBarHeader from '../appbar-header'
import Sidebar from '../sidebar'
import Routes from '../../routing/dashboard-routes/routes'
import storage from '@/utils/storage'
import { MainLayoutProps } from './types'
import SidebarItem from '../sidebar/sidebar-item'

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery('(max-width:900px)')
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const location = useLocation()
  const userRole = storage.getUserRole()
  const isAdmin = storage.getUserAdmin()

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen)
  }

  const activeRoute = (routeName: any) => {
    return location.pathname === routeName ? true : false
  }

  const filterByRole = (route: any) => {
    if (route.path === '/admin-console') {
      return isAdmin === true
    }
    return userRole
      ? route.userRole === userRole || route.userRole === 'both'
      : route.isPublic
  }

  const MobileSidebar = () => (
    <MenuList sx={{ padding: '0px' }}>
      {Routes.filter((route) => !route.isHidden)
        .filter((route) => filterByRole(route))
        .map((route, key) => (
          <SidebarItem
            key={key}
            route={route}
            isActive={activeRoute(route.path)}
            isMobile={true}
            onItemClick={() => setMobileMenuOpen(false)}
          />
        ))}
    </MenuList>
  )

  return (
    <Stack direction="row" flex={1} overflow="hidden" height="100vh">
      {!isMobile && <Sidebar />}
      {isMobile && (
        <Drawer
          anchor="left"
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
          sx={{
            '& .MuiDrawer-paper': {
              width: 240,
            },
          }}
        >
          <MobileSidebar />
        </Drawer>
      )}
      <Stack direction="column" flex={1}>
        <Stack
          direction="row"
          alignItems="center"
          sx={{ background: '#000000' }}
        >
          {isMobile && (
            <IconButton
              onClick={toggleMobileMenu}
              sx={{ color: 'white', ml: 1 }}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Stack flex={1}>
            <AppBarHeader />
          </Stack>
        </Stack>
        <Stack
          direction="column"
          flex={1}
          sx={{ background: '#F3F3F3', overflowY: 'auto', overflowX: 'hidden' }}
        >
          {children}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default MainLayout
